import { createTheme, responsiveFontSizes } from "@mui/material";

let DarkTheme = createTheme({
  typography: {
    fontFamily: '"Montserrat", sans-serif',
  },
  palette: {
    mode: "dark",
    primary: {
      main: '#712b2b',
    },
    secondary: {
      main: '#66bb6a',
    },
    background: {
      default: "#20252b",
    },
    text2: {
      primary: "#dfe3ebff",
      secondary: "#b6bac1ff"
    }
  },
  components: {
    MuiTextField: {
    defaultProps: {
      variant: "outlined"
    }
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        backgroundColor: "#303030ff", // pozadina polja
        borderRadius: 8,
        color: "#eeeff0ff", // boja teksta
      },
      input: {
        padding: "12px",
      }
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      notchedOutline: {
        borderColor: "#4b4b4bff"
      },
      root: {
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#5a5a5aff"
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#636d7bff",
          borderWidth: "2px"
        }
      }
    }
  },
    MuiContainer: {
      styleOverrides: {
        root: {
          borderRadius: 12
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 12
        }
      }
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 12
        }
      }
    }
  },
  shape: {
    borderRadius: 12
  },
  shadows: [
    "none",
    "rgba(9, 30, 66, 0.25) 0px 4px 6px -5px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px",
    "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px",
    "rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px",
    "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(72, 78, 87, 1) 0px 0px 0px 1px inset",
    "0 1px 5px rgb(0 0 0 / 15%)",
    "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgb(209, 213, 219) 0px 0px 0px 1px inset",
    "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
    "rgba(0, 0, 0, 0.05) 0px 0px 0px 1.25px",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ]
});

DarkTheme = responsiveFontSizes(DarkTheme);

export default DarkTheme;